module.exports = __webpack_public_path__ + "img/left-arrow.0ea49aca.svg";